import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { client } from "../core/client"

// ---------------------
// AUTH WRAPPER
// Auth hooks call the client directly to avoid circular deps with generated/hooks
// ---------------------

export function useMe() {
  const query = useQuery({
    queryKey: ["auth", "me"],
    queryFn: async () => {
      const res = await client.GET("/auth/me/" as any, {} as any)
      if (res.error) throw res.error
      return res.data
    }
  })

  return {
    ...query,
    user: query.data,
    isAuthenticated: !!query.data
  }
}

export function useLogin() {
  const mutation = useMutation({
    mutationFn: async (body: { identifier: string; password: string }) => {
      const res = await client.POST("/auth/login/" as any, { body } as any)
      if (res.error) throw res.error
      return res.data
    }
  })
  const qc = useQueryClient()

  return {
    ...mutation,

    async login(data: { identifier: string; password: string }) {
      const res = await mutation.mutateAsync(data)

      // 🔥 invalidate ALL auth queries (important for SSR sync)
      await qc.invalidateQueries({ queryKey: ["auth"] })

      return res
    }
  }
}

export function useLogout() {
  const mutation = useMutation({
    mutationFn: async () => {
      const res = await client.POST("/auth/logout/" as any, {} as any)
      if (res.error) throw res.error
    }
  })
  const qc = useQueryClient()

  return {
    ...mutation,

    async logout() {
      await mutation.mutateAsync()

      // 🔥 clear cache completely
      qc.clear()
    }
  }
}